// extracted by mini-css-extract-plugin
export default {"custom-sidebar":"SignInButton_custom-sidebar__PwObJ","tertiary-badge":"SignInButton_tertiary-badge__N+T-W","signInButton":"SignInButton_signInButton__5BfNk"};